module.exports = __webpack_public_path__ + "static/img/undraw_mobile_apps_4wgf.0cfb4f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/undraw_mobile_apps_4wgf.png
// module id = z6ir
// module chunks = 3